<app-dashboard-layout [notDashboard]="true" [downloader]="downloader" [loading]="loading || skeletonLoader">
    <section class="bg-white border rounded-md p-4">
        <header class="border-b flex text-lg w-full pb-6 gap-8 md:text-xl">
            View all complaint:
        </header>

        <app-notification-alert [data]="notification"></app-notification-alert>

        <section *ngIf="skeletonLoader">
            <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
            <div class="border rounded-md mx-auto max-w-md bg-gray-300 h-8 my-8 animate-pulse"></div>
        </section>

        <div *ngIf="!skeletonLoader" class="overflow-x-auto relative shadow-md sm:rounded-lg">
            <table class="w-full text-sm text-left">
                <thead class="text-xs text-white uppercase bg-primary/90">
                    <tr>
                        <th scope="col" class="py-3 px-6">
                            Reference Number
                        </th>
                        <th scope="col" class="py-3 px-6">
                            Body
                        </th>
                        <th scope="col" class="py-3 px-6">
                            Created on
                        </th>
                        <th scope="col" class="py-3 px-6">
                            Status
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let complaint of payload" class="text-gray-700 text-sm">
                        <th scope="row" class="py-4 px-6 font-medium whitespace-nowrap">
                            {{complaint.ComplainRefNumber}}
                        </th>
                        <td class="py-4 px-6">
                            {{complaint.Description}}
                        </td>
                        <td class="py-4 px-6">
                            {{complaint.CreatedDateTime | date: "MMM d, y, h:mm a"}}
                        </td>
                        <td class="py-4 px-6">
                            {{complaint.ComplaintStatus}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</app-dashboard-layout>